/*** IMPORTS FROM imports-loader ***/
var define = false;

import filter from './filter.js';
import matcher from './matcher.js';

// Convenience version of a common use case of `_.filter`: selecting only
// objects containing specific `key:value` pairs.
export default function where(obj, attrs) {
  return filter(obj, matcher(attrs));
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/where.js
// module id = 196
// module chunks = 0